import { atom } from 'jotai'

import { websiteUrlAtom } from '../../contentFormSections/WebsiteUrlForm'
import { QR_TYPE } from '../../generatorTypes'

export type TUrlContent = {
	type: QR_TYPE.Url
	url: string
}

export const websiteUrlContentAtom = atom<TUrlContent, [TUrlContent], void>(
	(get) => ({
		type: QR_TYPE.Url,
		url: get(websiteUrlAtom),
	}),
	(_, set, content: TUrlContent) => {
		set(websiteUrlAtom, content.url)
	},
)
